import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { LoadLogoLogin } from "../../Layouts/LoadLogo";
import logoSped from "../../assets/images/logo-sped.png";
import useLogoLoader from "../../Components/Hooks/useLogoLoaderHooks";

const AuthSlider = () => {
    const { logoSrc, isSettingsLoading } = useLogoLoader("login");

    return (
        <Col lg={6}>
            <div className="p-lg-5 p-4 auth-one-bg h-100">
                <div className="bg-overlay"></div>
                <div className="position-relative h-100 d-flex flex-column justify-content-center">
                    <div className="text-center" style={{ marginBottom: '40px' }}>
                        <img src={logoSped} alt="Logo Sped" height='40' />
                    </div>
                    <div className="text-center ff-bas fs-14 fw-medium text-uppercase text-muted" style={{ margin: '13px' }}>
                        al servicio de
                    </div>
                    <div className="text-center" style={{ marginTop: '40px' }}>
                        <LoadLogoLogin
                            logoSrc={logoSrc}
                            isSettingsLoading={isSettingsLoading}
                            maxHeight={60}
                            maxWidth={'80%'}
                        />                        
                    </div>
                </div>
            </div>
        </Col>
    );
};

export default AuthSlider;
